import ImageSettings from './toolbar/image-settings.js';
import ImageEditor from './imageStudio/image-editor.js';
import 'react';
import 'prop-types';
import 'classnames';
import 'wix-rich-content-common';
import 'wix-rich-content-common/libs/imageUtils';
import 'wix-rich-content-ui-components';
import './style-inject.es-746bb8ed.js';
import './consts.js';
import 'ricos-schema';
import './imageStudio/image-editor-logic.js';
import './imageStudio/image-studio-opener-loader.js';

const Modals = {
  IMAGE_SETTINGS: "image-settings",
  IMAGE_EDITOR: "image-editor"
};
const ModalsMap = {
  [Modals.IMAGE_SETTINGS]: ImageSettings,
  [Modals.IMAGE_EDITOR]: ImageEditor
};

export { Modals, ModalsMap };
//# sourceMappingURL=modals.js.map
